import { Col, Collapse, Form, Input, InputNumber, Row, Select } from 'antd';
import React, { Dispatch } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Action } from 'typesafe-actions';
import ClearFilterBtn from '../../../../../../components/ClearFilterBtn';
import CollapseFilter from '../../../../../../components/CollapseFilter';
import FilterBtn from '../../../../../../components/FilterBtn';
import FilterContainer from '../../../../../../components/FilterContainer';
import TextFilter from '../../../../../../components/TextFilter';
import CollapseTitle from '../../../../../../components/TitleCollapseFilter';
import { ApplicationState } from '../../../../../../store';
import {
  cleanStateEntregaCD,
  filterEntregaCD,
  loadRequest,
} from '../../../../../../store/ducks/entregaNoCd/actions';
import { SelectTransportadoraParceira } from '../../../../../../components/_REFACTORED/SelectTransportadoraParceira';
import { SelectTipoVeiculo } from '../../../../../../components/_REFACTORED/SelectTipoVeiculo';

const Filter: React.FC = () => {
  const { Option } = Select;
  const { Panel } = Collapse;
  const dispatch = useDispatch<Dispatch<Action>>();

  const parceiros = useSelector((state: ApplicationState) => state.auth.inscricaoAtiva);
  const codCdd = useSelector((state: ApplicationState) => state.auth.cddAtivo);
  const sorter = useSelector((state: ApplicationState) => state.EntregaNoCd.sorter);
  const pagCurrent = useSelector((state: ApplicationState) => state.EntregaNoCd.pagination.current);
  const filter = useSelector((state: ApplicationState) => state.EntregaNoCd.filter);

  const clearFilter = (): void => {
    localStorage.removeItem(window.location.pathname + `valuesFilter`);
    localStorage.removeItem(`responseTiposVeiculosFilter${window.location.pathname}`);
    localStorage.removeItem(`responseTransportadorasFilter${window.location.pathname}`);

    dispatch(cleanStateEntregaCD());
    dispatch(loadRequest(undefined, parceiros, codCdd?.codCdd as number));
  };

  const onFilter = (values: any): void => {
    Object.keys(values).forEach((key) => {
      if (values[key] === undefined || values[key] === null || values[key] === '') {
        delete values[key];
      }
    });
    localStorage.setItem(
      window.location.pathname + 'valuesFilter',
      JSON.stringify({ ...filter, ...values })
    );
    dispatch(filterEntregaCD({ ...filter, ...values }));
  };

  return (
    <CollapseFilter
      filter={filter}
      pagination={pagCurrent}
      sorter={sorter}
      loadRequest={loadRequest}
      saveFilter={filterEntregaCD}
      saveLocalStorage={'persist:EntregaNoCd'}
    >
      <Panel header={<CollapseTitle>Filtro</CollapseTitle>} key="1">
        <FilterContainer onFilter={onFilter}>
          <Row gutter={24}>
            <Col md={6} sm={24} xs={24}>
              <Form.Item label={<TextFilter>Ordem de carga</TextFilter>} name="ordemCarga">
                <InputNumber
                  type="number"
                  style={{ width: '100%' }}
                  min={0}
                  placeholder="Digite o número da ordem de carga"
                />
              </Form.Item>
            </Col>

            <Col md={6} sm={24} xs={24}>
              <Form.Item label={<TextFilter>Status</TextFilter>} name="status">
                <Select
                  getPopupContainer={(triggerNode: HTMLElement) =>
                    triggerNode.parentNode as HTMLElement
                  }
                  placeholder="Selecione um status"
                >
                  <Option value={'AGA'}>Aguardando agendamento</Option>
                  <Option value={'AGE'}>Agendado</Option>
                  <Option value={'EXP'}>Expedido</Option>
                </Select>
              </Form.Item>
            </Col>

            <Col md={6} sm={24} xs={24}>
              <SelectTransportadoraParceira />
            </Col>

            <Col md={6} sm={24} xs={24}>
              <SelectTipoVeiculo />
            </Col>
          </Row>

          <Row gutter={24}>
            <Col md={6} sm={24} xs={24}>
              <Form.Item label={<TextFilter>Placa</TextFilter>} name="placa">
                <Input style={{ width: '100%' }} placeholder="Digite a placa" />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={24} justify="end">
            <Col md={6} sm={24} xs={24}>
              <ClearFilterBtn onClick={clearFilter}>Limpar filtros</ClearFilterBtn>
            </Col>
            <Col md={6} sm={24} xs={24}>
              <FilterBtn>Filtrar</FilterBtn>
            </Col>
          </Row>
        </FilterContainer>
      </Panel>
    </CollapseFilter>
  );
};

export default Filter;
